import styled from "styled-components";
import { motion } from "framer-motion";

const CancelButton = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  padding: 8px !important;
  padding-right: 12px !important;
  margin-top: 0px !important;
  cursor: pointer;
  gap: 2px;
  svg {
    rect {
      fill: var(--cta-text-color);
    }
  }
`;

function CancelProseGenerationButton({ onCancel }) {
  return (
    <CancelButton
      onClick={onCancel}
      initial={{
        background: `linear-gradient(90deg,  var(--primary-cta) ${0}%, var(--primary-cta-light) ${0}%)`,
      }}
      animate={{
        background: `linear-gradient(90deg, var(--primary-cta)  ${90}%, var(--primary-cta-light) ${10}%)`,
        transition: {
          duration: 30,
          ease: "linear",
        },
      }}
    >
      <p>Cancel</p>
    </CancelButton>
  );
}

export default CancelProseGenerationButton;
